import type { MapLayer } from '@app/types/layerTypes'
import { HazardOptionStateByHazard } from '@app/components/Molecules/RiskSideDrawerContent/tabs/InformativePanel/LayersTab/HazardControls/HazardControls'

export type ActiveHazardParameters = 'all' | 'onlyslr' | 'none'

export function buildHazardOptionState(
  layers: MapLayer[],
  activeHazardParameters: ActiveHazardParameters,
): HazardOptionStateByHazard {
  const result: HazardOptionStateByHazard = {}

  layers.forEach((layer) => {
    if (layer.layerType !== 'hazard') return
    if (!layer.parameters) return

    const hazardId = layer.hazard_id
    if (hazardId === undefined) return

    Object.entries(layer.parameters).forEach(([key, value]) => {
      const isControlled =
        activeHazardParameters === 'all' || (activeHazardParameters === 'onlyslr' && key === 'slr')

      if (!isControlled) return

      result[hazardId] ??= []

      const alreadyExists = result[hazardId].some((option) => option.key === key)

      if (!alreadyExists) {
        result[hazardId].push({
          key,
          value,
        })
      }
    })
  })

  return result
}
